export const environment = {
  production: true,
  appURL: 'https://dev.stelviotech.com',
  apiURL: 'https://dev.stelviotech.com/api',
  passportApiURL: 'https://dev.stelviotech.com/api',
  publicPassportContentEnabled: false,
  // NOTE (2026-09-25, security pass): the auth block (grant_type=password +
  // hardcoded Keycloak client secret) that used to live here was dead code --
  // this Ionic app has no login flow, it only calls unauthenticated
  // public-passport endpoints (see
  // src/app/common/services/public-passport-content.service.ts). Removed
  // rather than kept, so no secret ships in this bundle at all.
  pagination: {
    pageSize: 20
  },
  appVersion: 'v8.0.38',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appHTMLIntegration: 'https://preview.keenthemes.com/metronic8/demo6/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo6/',
  appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular/demo6',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl: 'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
};
